import { call, put } from 'redux-saga/effects'

import { postApi } from '../helpers/fetchApi'

import {
  fetchFeaturedProductsFailure,
  fetchFeaturedProductsSuccess
} from '../../actionCreators/featuredProducts/featuredProductsActionCreators'
import Logger from '../../helpers/Logger'

const logger = Logger.getInstance()
const endpoint = '/citrus-api/'

const buildFeatureProduct = response => ({
  products: response.ads.map(ad => ({ id: ad.gtin, ad_id: ad.id }))
})

function* featuredProductsSaga(action) {
  const { payload } = action
  const { userid, taxonomy, partNumber, brand = '', brandRestrict = false } = payload

  const productFilters = taxonomy.split(' / ').map(id => [`taxonomy:${id}`])

  const conf = {
    production: {
      catalogId: 'f5a9270b-e5b9-42bb-80ab-43b342d0a7e2'
    },
    staging: {
      catalogId: '73602921-7426-4195-8f22-9603c19beefd'
    }
  }

  const servicePayload = {
    placement: 'pdp-desktop',
    customerId: userid,
    sessionId: userid,
    catalogId: process.env.MESOS_ENV === 'production' ? conf.production.catalogId : conf.staging.catalogId,
    productFilters,
    maxNumberOfAds: 6,
    options: {
      filterMode: 'AndOr'
    }
  }

  if (brandRestrict && brand.trim() !== '') {
    servicePayload.productFilters.push([`brand:${brand}`])
  }

  try {
    const jsonData = yield call(postApi, `${endpoint}`, { ...servicePayload })

    const actionPayload = {
      partNumber,
      data: buildFeatureProduct(jsonData)
    }
    const successAction = fetchFeaturedProductsSuccess(actionPayload)
    return yield put(successAction)
  } catch (error) {
    const errorDetail = {
      message: error?.message,
      status: error?.status || error?.statusCode,
      name: error?.name,
      stack: error?.stack
    }
    const failureAction = fetchFeaturedProductsFailure({ partNumber, errorDetail })
    logger.error('hookLogicFeaturedProducts', { payload, error }, 'hookLogicFeaturedProducts error')
    return yield put(failureAction)
  }
}

export { endpoint, featuredProductsSaga }
